import { render, staticRenderFns } from "./Evaluation-approved.vue?vue&type=template&id=228e1184"
import script from "./Evaluation-approved.vue?vue&type=script&lang=js"
export * from "./Evaluation-approved.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports